export const applyDiscountPromotion = (promotionDiscountedPrice: any, variant: any) => {
    if (promotionDiscountedPrice.DISCOUNT_PROMOTION) {
        if (variant && promotionDiscountedPrice.DISCOUNT_PROMOTION.value["GUEST"]) {
            variant.comparePriceFull = promotionDiscountedPrice.DISCOUNT_PROMOTION.value["GUEST"].price;
        }
        if (variant && promotionDiscountedPrice.DISCOUNT_PROMOTION.value["BP"]) {
            variant.comparePriceTrial = promotionDiscountedPrice.DISCOUNT_PROMOTION.value["BP"].price;
        }
    }

    return variant;
};
